import { render } from "./RestoreConfirmationModal.vue?vue&type=template&id=298c4632"
import script from "./RestoreConfirmationModal.vue?vue&type=script&lang=js"
export * from "./RestoreConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__